import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';

import { LoginPageComponent } from './login-page/login-page.component';
import { PostLoginPageComponent } from './post-login-page/post-login-page.component';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    LoginPageComponent,
    PostLoginPageComponent
    ],
  exports: [
    LoginPageComponent
  ],
  providers: []
})
export class LoginModule {
}
